import {Injectable} from "@angular/core";
import {MessageService} from "../messaging/message.service";
import {JwtHttpClientService} from "../http/jwt-http-client.service";
import {AuthService} from "../auth/auth.service";
import {MessageSeverity} from "../messaging/message.model";
import {catchError, EMPTY, first, timer} from "rxjs";

/**
 * Actively pings to determine the offline status
 */
@Injectable()
export class HealthCheckService {

    private static POLL_DELAY = 60000;

    /**
     * Indicates that the polling service is running
     */
    private polling: boolean;

    constructor(private http: JwtHttpClientService, private messageService: MessageService, private authService: AuthService) {

    }


    public init(): void {
        this.initNextPoll();
    }

    /**
     * Indicates that the client is offline.
     */
    public notifyOffline(): void {
        this.messageService.send({
            id: "offline",
            title: "wo.connection-status.message.offline",
            severity: MessageSeverity.Critical,
            value: 0
        });
    }

    public notifyOnline(): void {
        this.messageService.complete("offline");
    }


    private initNextPoll(): void {
        if (!this.polling) {
            this.polling = true;
            timer(HealthCheckService.POLL_DELAY).pipe(first()).subscribe(() => this.ping());
        }
    }

    private ping(): void {
        if (this.authService.isLoggedIn()) {
            this.http.getWithoutToken("/dataserver/ping").pipe(
                catchError(() => {
                    this.notifyOffline();
                    this.polling = false;
                    this.initNextPoll();
                    return EMPTY;
                })
            ).subscribe(() => {
                this.notifyOnline();
                this.polling = false;
                this.initNextPoll();
            });
        } else {
            this.notifyOnline();
            this.polling = false;
            this.initNextPoll();
        }
    }
}
